import {WhatsNewPeriod} from 'modules/decisionsNext/sections/WhatsNewSection/constants';
import {dayjs, now} from 'utils/dateUtils';
import {localStorageKey} from 'core/constants';

export const checkIsPeriodMatch = (date: Date, period: WhatsNewPeriod) => {
  const now = dayjs();
  const targetDate = dayjs(date);

  switch (period) {
    case WhatsNewPeriod.All:
      return true;
    case WhatsNewPeriod.Today:
      return targetDate.isSame(now, 'day');
    case WhatsNewPeriod.LastSevenDays:
      return targetDate.isAfter(now.subtract(7, 'day'), 'day');
    case WhatsNewPeriod.LastThirtyDays:
      return targetDate.isAfter(now.subtract(30, 'day'), 'day');
    case WhatsNewPeriod.LastYear:
      return targetDate.isAfter(now.subtract(1, 'year'), 'day');
    default:
      return false;
  }
};

export function saveWhatsNewToastLatestSeenDate() {
  localStorage.setItem(localStorageKey.WhatsNewToastLastSeenDate, now());
}

export function deleteWhatsNewToastLatestSeenDate() {
  localStorage.removeItem(localStorageKey.WhatsNewToastLastSeenDate);
}
